
import { Component, Input, OnInit, signal } from '@angular/core';
import { Instance } from '../../models/instance';
import { DescriptionService } from '../../core/services/description/description.service';
import { Description } from '../../models/description';
import { FormBuilder, FormGroup, FormsModule } from '@angular/forms';
import { ModalService } from '../../core/services/modal/modal.service';
import { ModalComponent } from '../../shared/components/modal/modal.component';
import { FriendlyDatePipe } from '../../pipes/friendly-date.pipe';
import { FilterBySearchPipe } from '../../pipes/filter-by-search.pipe';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AgentWritableDirective } from '../../shared/directives/agent-writable.directive';
import { LoadingSpinnerComponent } from '../../shared/components/loading-spinner/loading-spinner.component';
import { IconTrashComponent } from '../../shared/components/icon-trash/icon-trash.component';

@Component({
  selector: 'app-description-list',
  standalone: true,
  imports: [
    FormsModule,
    ModalComponent,
    FriendlyDatePipe,
    AgentWritableDirective,
    FilterBySearchPipe,
    TranslatePipe,
    TranslatePipe,
    LoadingSpinnerComponent,
    IconTrashComponent
  ],
  templateUrl: './description-list.component.html',
  styleUrl: './description-list.component.css'
})
export class DescriptionListComponent {

  modalValue = signal(0);
  descriptionForm: FormGroup;
  @Input() instance: Instance | undefined;
  @Input() descriptions: Description[];
  @Input() showDescription: boolean = false;
  @Input() customerId: number | null = null;
  newDescription: string = '';
  showSearch = false;
  searchTerm: string;
  selectedIds: number[] = [];

  constructor(
    private fb: FormBuilder,
    private descriptionService: DescriptionService,
    private modalService: ModalService,
    private translate: TranslateService,
  ) { }

  deleteDescriptions() {
    this.modalService.closeModal();
    this.modalValue.set(0);
    const descriptions = this.descriptions.filter((description: any) => this.selectedIds.includes(description.id));
    this.descriptionService.deleteDescriptions(descriptions).subscribe(
      (res) => {
        if (this.descriptions) {
          this.descriptions = this.descriptions.filter(
            (description: any) => !this.selectedIds.includes(description.id)
          );
          this.selectedIds = [];
          this.modalService.notifier(this.translate.instant('DESCRIPTION.MESSAGES.DESCRIPTION_DELETED'), "", "success");
        }
      },
      (err) => {
        this.modalService.notifier(this.translate.instant('DESCRIPTION.MESSAGES.DELETE_IMPOSSIBLE'), "", "error");
      }
    )
  }

  createDescription() {
    if (!this.newDescription.trim()) return;

    const value = {
      details: this.newDescription,
      instance: this.instance
    };
    this.descriptionService.createDescription(value).subscribe(
      (res) => {
        this.descriptions.push(res as Description);
        this.newDescription = '';
        this.modalService.notifier(this.translate.instant('DESCRIPTION.MESSAGES.DESCRIPTION_CREATED'), "", "success");
      },
      (err) => {
        this.modalService.notifier(this.translate.instant('DESCRIPTION.MESSAGES.CREATION_FAILED'), "", "error");
      }
    );
  }

  openModal(value: number) {
    this.modalValue.set(value);
    this.modalService.openModal();
  }

  closeModal() {
    this.modalService.closeModal();
    this.modalValue.set(0);
  }

  isAllSelected(): boolean {
    const allIds = this.getAllIds();
    return allIds.every(id => this.selectedIds.includes(id));
  }

  toggleAllSelection(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.selectedIds = checked ? this.getAllIds() : [];
  }

  getAllIds(): number[] {
    const ids: number[] = [];
    this.descriptions?.forEach((description: any) => {
      ids.push(description.id);
    })
    return ids;
  }

  isSelected(id: number) {
    return this.selectedIds.includes(id);
  }

  toggleSelection(id: number): void {
    if (this.isSelected(id)) {
      this.selectedIds = this.selectedIds.filter(item => item !== id);
    } else {
      this.selectedIds.push(id);
    }
  }
}
